import Api from "../lib/Api";
import { GET_ALL_LEADS } from "./types";

export const uploadLeads = body => async dispatch => {
  try {
    const response = await Api.post(body, '/sli/leads/upload');
    dispatch(getAllLeads())
    return response.data
  } catch (e) {
    console.log(e.message)
    return false;
  }
};

export const triggerLink = body => async dispatch => {
  try {
    const response = await Api.post(body, '/sli/leads/link');
    //dispatch(getAllLeads())
    console.log(response)
    return response;
  } catch (e) {
    console.log(e.message)
    return {};
  }
};

export const getAllLeads = body => async dispatch => {
  try {
    const response = await Api.get('/sli/leads');
    dispatch({
      type: GET_ALL_LEADS,
      payload: response.data
    })
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const approveAssignment = body => async dispatch => {
  try {
    await Api.post(body, '/sli/assignment/approve');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const rejectAssignment = body => async dispatch => {
  try {
    await Api.post(body, '/sli/assignment/reject');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const raiseFr = body => async dispatch => {
  try {
    await Api.post(body, '/sli/assignment/fr');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const uploadDocument = body => async dispatch => {
  try {
    await Api.post(body, '/sli/assignment/upload');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const uploadAadhaarDocument = body => async dispatch => {
  try {
    await Api.post(body, '/sli/upload/aadhaardocument');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const uploadSelfie = body => async dispatch => {
  try {
    await Api.post(body, '/sli/upload/photo');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const submitLead = body => async dispatch => {
  try {
    const response = await Api.post(body, '/sli/leads/addLead');
    dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}

export const updateAlternateNumber = body => async dispatch => {
  try {
    const response = await Api.post(body, '/sli/updateAlternateNumber');
    //dispatch(getAllLeads())
  } catch (e) {
    console.log(e.message)
    return false;
  }
}